




















































import Vue from 'vue';
import axios from 'axios';
import eventBus from '@/eventBus';

export default Vue.extend({
  name: 'HotelBooking',
  props: {
    hotelId: Number,
  },
  data: () => ({
    form: {
      email: '',
      name: '',
      tel: '',
    },
  }),
  methods: {
    onSubmit(e: { target: HTMLFormElement }): void {
      const form = e.target;

      if (this.form.name !== '' && this.form.email !== '' && this.form.tel !== '') {
        // axios
        //   .post('/#', {
        //     body: new FormData(form),
        //   })
        //   .then(response => {
        //     console.log(response);
        //   })
        //   .catch(error => {
        //     console.log(error);
        //   });

        eventBus.$emit('showSuccesModal', 'SuccesModal');
      }
    },
  },
});
